const thirdPartyServicesReducer = (state = {}) => state;

export default thirdPartyServicesReducer;
